import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { AppConfig } from 'src/assets/config/config/app-config';

declare var $: any;

@Injectable({ providedIn: 'root' })
export class ECMService {

  apiUrl: string;
  guestUsername: string;
  constructor(
    private http: HttpClient,
    private appConfig: AppConfig
  ) {
    this.apiUrl = this.appConfig.getConfig("serviceurl");    
    this.guestUsername = this.appConfig.getConfig("guestUsername");
  }


  viewDocument(documentId, userName): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
          'dms-user': userName
      })           
    };
    if (userName === this.guestUsername) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.appConfig.getConfig("authtoken")
        })           
      };
    }

    return this.http
      .get<any>(this.apiUrl + `/documents/view/` + documentId, httpOptions)
      .pipe();
  }

  shareDocument(documentId, userName): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
          'dms-user': userName
      })           
    };
    if (userName === this.guestUsername) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.appConfig.getConfig("authtoken")
        })           
      };
    }

    return this.http
      .get<any>(this.apiUrl + `/documents/share/${documentId}/720`, httpOptions)
      .pipe();
  }



  private handleError<T>(operation = 'operation', result?: T) {
    //alert(JSON.stringify(err));
    //o: T;
    //alert(typeof o);
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead

        // this.snackBar.open(String(error).replace('error:', 'ERROR:  '), '', {
        //   duration: 5000,
        // });

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
      //return result;
    };
  }


}
